<div class="relative grid grid-cols-1 justify-items-center gap-8 rounded-xl bg-white p-8 shadow-lg select-none">
  <h2 class="font-family-din text-center text-xl font-medium">{{ title() }}</h2>
  <div class="flex gap-4">
    @let _rating = rating();
    @for (label of starLabels; track label) {
      <rid-rating-star [label]="starsOnly() ? undefined : label" [filled]="$index < litCount()" (click)="rate($index)" />
    }
  </div>
  @if (!starsOnly()) {
    <div class="grid w-max grid-cols-2 gap-4">
      <rid-button content="Terug" variant="SECONDARY" [disabled]="_rating === undefined" (click)="cancel()" />
      <rid-button content="Volgende" [disabled]="_rating === undefined" (click)="next()" />
    </div>
  }
</div>
